export default "__VITE_ASSET__D_ly53z9__"